"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.share = void 0;

var _Schema = require("../Schema");

/**
 * A user clicks or taps the 'Share' button.
 *
 *  @example
 *  ```
 *  share({
 *    context_module: "artworkImage",
 *    context_owner_type: "artwork",
 *    context_owner_id: "55ed8ca57261693d930000b8"
 *    service: "instagram_stories"
 *  }
 * ```
 */
var share = function share(_ref) {
  var context_module = _ref.context_module,
      context_owner_type = _ref.context_owner_type,
      context_owner_id = _ref.context_owner_id,
      context_owner_slug = _ref.context_owner_slug,
      service = _ref.service;
  return {
    action: _Schema.ActionType.share,
    context_module: context_module,
    context_owner_id: context_owner_id,
    context_owner_slug: context_owner_slug,
    context_owner_type: context_owner_type,
    service: service
  };
};

exports.share = share;